// eslint-disable-next-line no-restricted-imports
import { ButtonFrameless } from 'components/ButtonFrameless'
import { ButtonFramelessProps } from 'components/ButtonFrameless/types'
import styled from 'styled-components/macro'

export const Page = styled(ButtonFrameless)<
  ButtonFramelessProps & {
    isCurrentPage?: boolean
    disabled?: boolean
    onClick: (page: number) => void
  }
>`
  /* DS rounded page chip (mirrors FhPagination): hairline-bordered white chip,
     solid deep-purple active fill with on-primary ink.
     Force square geometry — StyledTextButton defaults (padding/min-width/height)
     otherwise win the cascade and make the page number look uneven (ENG-2564). */
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-brand);
  border-radius: var(--radius-sm);
  height: 2.5rem !important;
  width: 2.5rem;
  min-width: 2.5rem !important;
  max-width: 2.5rem;
  padding: 0 !important;
  line-height: var(--mantine-line-height-flat);
  background-color: var(--surface-card);
  color: var(--gray-600);

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
  }
  ${({ isCurrentPage }) =>
    isCurrentPage &&
    `
    &, &:active, &:focus, &:hover, &:focus:not(:active):not(:hover) {
      background-color: var(--action-primary);
      border-color: var(--action-primary);
      color: var(--action-on-primary);
    }
  `}
  &:disabled {
    color: inherit;
  }
`

export const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  font-size: var(--mantine-font-size-md);
  & > * {
    margin: 0 0.4rem;
  }
`

export const Nav = styled(ButtonFrameless)<ButtonFramelessProps>`
  /* DS "Next" pill / nav arrow control (mirrors FhPagination): hairline-bordered
     white chip, brand-ink label, rounded corners. */
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  height: 2.5rem !important;
  min-height: 2.5rem !important;
  min-width: unset !important;
  padding: 0 1rem !important;
  border: 1px solid var(--border-brand);
  border-radius: var(--radius-sm);
  background-color: var(--surface-card);
  color: var(--text-heading);
`
